import { render, staticRenderFns } from "./postTransactionCustomerList.vue?vue&type=template&id=4be694b8"
import script from "./postTransactionCustomerList.vue?vue&type=script&lang=js"
export * from "./postTransactionCustomerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports